module.exports = __webpack_public_path__ + "img/6.633844e1.png";